"use strict"
exports.__esModule = true;
exports.DigitalOceanIconConfig = {
  name: 'DigitalOceanIcon',
  height: 512,
  width: 512,
  svgPath: 'M87 481.8h73.7v-73.6H87zM25.4 346.6v61.6H87v-61.6zm466.2-169.7c-23-74.2-82.4-133.3-156.6-156.6C164.9-32.8 8 93.7 8 255.9h95.8c0-101.8 101-180.5 208.1-141.7 39.7 14.3 71.5 46.1 85.8 85.7 39.1 107-39.7 207.8-141.4 208v.3h-.3V504c162.6 0 288.8-156.8 235.6-327.1zm-235.3 231v-95.3h-95.6v95.6H256v-.3z',
  yOffset: 0,
  xOffset: 0,
};
exports.DigitalOceanIcon = require('../createIcon').createIcon(exports.DigitalOceanIconConfig);
exports["default"] = exports.DigitalOceanIcon;